import { ConstantsParser } from '../../../ConstantsParser'
export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
      alt: 'an awesome image',
      srcType: 'media',
      srcSize: 'original',
      srcLink: null,
      src: null,
      clickAction: 'none',
      clickTarget: '__blank',
      link: ''
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    return `<img
      src="/img/placeholder.png"
      alt="placeholder"
      class="${classes}"
    />`
  }

  classes() {
    return [
      {property: 'Width', value: 'WIDTH_AUTO'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
    }
  }
}